class CustomScrollContent {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }
  event() {
    const contentWraps = document.querySelectorAll("." + this.el);
    contentWraps.forEach((ele) => {
      const seekBar = ele.querySelector("." + this.el + "__seek-bar");
      const content = ele.querySelector("." + this.el + "__scroll-area");
      const contentHeight = content.scrollHeight;
      const containerHeight = ele.offsetHeight;

      // シークバーのスクロールイベント
      content.addEventListener("scroll", () => {
        const scrollRatio = content.scrollTop / (contentHeight - containerHeight);
        gsap.to(seekBar, {
          height: `${scrollRatio * 100}%`,
          duration: 0.3,
          ease: "power1.out",
        });
      });

      // ドラッグでスクロール
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;

      seekBar.addEventListener("mousedown", (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = content.scrollTop;
        document.body.style.userSelect = "none"; // 選択を防止
      });

      document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        const deltaY = e.clientY - startY;
        const scrollRatio = deltaY / containerHeight;
        content.scrollTop = startScrollTop + scrollRatio * contentHeight;
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
        document.body.style.userSelect = ""; // 選択を復帰
      });
    });
  }
}
